import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import type { Stream } from "../../hooks";
import { StreamTaskListItem } from "./stream-task-list-item";

/** Props Interface */
interface StreamTaskListProps {
	stream: Stream;
	render?: (text: string) => React.ReactNode | null;
}

const MAX_LENGTH = 4;

export function StreamTaskList({ stream, render }: StreamTaskListProps) {
	/** Render */
	const [data, setData] = useState<string[]>([]);

	/** Effects */
	useEffect(() => {
		if (!stream) return;
		if (!stream.data) return;
		setData((prev) => {
			const _data = [...prev, stream.data];
			return _data.slice(-MAX_LENGTH);
		});
	}, [stream.data]);

	useEffect(() => {
		setData([]);
	}, [stream.streamId]);

	/** Guard */
	if (!data.length) return null;

	/** Render */
	return (
		<motion.div
			className="v-stack"
			animate={{
				height: "auto",
			}}
		>
			<AnimatePresence mode="popLayout">
				{data.map((item, index) => (
					<StreamTaskListItem
						key={item}
						text={item}
						isDone={stream.isDone}
						isPending={index === data.length - 1}
						render={render}
					/>
				))}
			</AnimatePresence>
		</motion.div>
	);
}
